import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';
import { Separator } from '@change-corgi/design-system-legacy/components/content';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { useCurrentBreakpointValue } from '@change-corgi/design-system-legacy/responsive';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { useIsSunriseEnabled } from '../../hooks/isSunriseEnabled';
import { SignFormContainer } from '../signForm';
import { SignatureStatsActiveContainer } from '../stats/signatureStats';

const SideUnsignedContainerInner: React.FC = () => {
	const desktop = useCurrentBreakpointValue([false, true]);
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		<>
			<Heading as="h2" size={isSunriseEnabled ? 'h3' : 'h4'} mt={16} mb={16}>
				<Translate value="corgi.petition_gamma.petition_sign.sign_title" />
			</Heading>
			{desktop ? <SignFormContainer /> : <Spinner className="mx-auto mt-16 size-6" />}
		</>
	);
};

export const SideUnsignedContainer: React.FC = () => {
	return (
		<>
			<Box mb={16}>
				<SignatureStatsActiveContainer />
			</Box>
			<Separator />
			{/* using programmatic media query to allow lazy loading of the sign form in modal on mobile */}
			{/* Spinner is necessary for SSR */}
			<ClientRender placeholder={<Spinner className="mx-auto mt-16 size-6" />}>
				<SideUnsignedContainerInner />
			</ClientRender>
		</>
	);
};
